import Route from '@ember/routing/route'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import type RolloverStudentImportService from 'teacher-ui-client/services/rollover-student-import'

export default class ManageRolloverStudentImportInvalidRoute extends Route {
  @service rolloverStudentImport!: RolloverStudentImportService

  @service router!: RouterService

  buildRouteInfoMetadata() {
    return {
      hideFooter: true,
    }
  }

  beforeModel() {
    // Ensure the current file has failed validation before entering this route
    if (this.rolloverStudentImport.importJob.valid !== false) {
      void this.router.replaceWith('manage.rollover.steps.students')
    }
  }

  /**
   * Gravity responded with a 422 error code so import process has transitioned to this,
   * the 'invalid' route.
   */
  model() {
    return {
      errors: this.rolloverStudentImport.importJob.validationErrors,
    }
  }
}
